import Utils from '@/common/utils/utils';
import { IconButton, TableCell, TableRow, TextField } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { findNameDuplicate, removeNewLine } from '../../handler/ProductListHandler';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';

export default function NewLineProducts({
    setHasError,
    product,
    indexProduct,
    provided,
    snapshot,
    setListDataProduct,
}) {
    const onChangeValue = (e) => {
        let value = e.target.value;
        setListDataProduct(prevState => {
            const newInputs = [...prevState];
            newInputs[indexProduct] = { ...newInputs[indexProduct], name: value, error: '' };
            if (Utils.isEmptyString(value) || !value.trim()) {
                //validate required
                newInputs[indexProduct] = { ...newInputs[indexProduct], error: 'COMM01MSG11' };
                setHasError(true);
                return newInputs;
            } 
            else if(value?.length > ProductManagementConstant.MAX_LENGTH_NAME) {
                newInputs[indexProduct] = { ...newInputs[indexProduct], error: 'COMMSG022' };
                setHasError(true);
                return newInputs;
            }
            
            let nameDuplicate = findNameDuplicate(newInputs);
            setHasError(false);
            newInputs.forEach((item, i) => {
                if (
                    !nameDuplicate.includes(item.name) &&
                    item?.error === 'MSG-CM-DATA-DUPLICATION'
                ) {
                    newInputs[i] = { ...newInputs[i], error: '' };
                }
            });
            return newInputs;
        });
    };

    const handleInputBlur = () => {
        setListDataProduct(prevState => {
            const newInputs = [...prevState];
            if (Utils.isEmptyString(newInputs[indexProduct].name) || !newInputs[indexProduct].name.trim()) {
                //validate required
                newInputs[indexProduct] = { ...newInputs[indexProduct], error: 'COMM01MSG11' };
                setHasError(true);
            } 
            else if(newInputs[indexProduct].name?.length > ProductManagementConstant.MAX_LENGTH_NAME) {
                newInputs[indexProduct] = { ...newInputs[indexProduct], error: 'COMMSG022' };
                setHasError(true);
            } 
            else {
                // Kiểm tra trùng lặp trong các trường name
                const isDuplicate = newInputs.some(
                    (input, i) => i !== indexProduct && input.name.trim() === newInputs[indexProduct].name.trim()
                );

                if (isDuplicate) {
                    newInputs[indexProduct].error = 'MSG-CM-DATA-DUPLICATION';
                    setHasError(true);
                } else {
                    // clear error
                    newInputs[indexProduct] = { ...newInputs[indexProduct], error: '' };
                    const hasError = newInputs.some(input => input.error);
                    setHasError(hasError);
                }
            }
            return newInputs;
        });
    };

    return (
        <TableRow
            key={product.id}
            className={`item-product ${snapshot.isDragging ? 'dragging' : ''}`}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
        >
            <TableCell className="table-row-top cell-input-newline-prod">
                <TextField
                    variant="outlined"
                    className="input-add-newline-prod"
                    placeholder="製品名"
                    onChange={onChangeValue}
                    onBlur={handleInputBlur}
                    value={product?.name}
                    error={!Utils.isEmptyString(product?.error)}
                    helperText={I18n.get(product.error)?.replace('{{maxLength}}', ProductManagementConstant.MAX_LENGTH_NAME)}
                />
            </TableCell>
            <TableCell className="btn-delete-newline table-row-top">
                <IconButton onClick={() => removeNewLine(indexProduct, setListDataProduct)}>
                    <img src="/assets/image/delete-icon.svg" alt="" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
}
